import $ from 'jquery';

export const init = () => {
	const TIMEOUT_MS = 2000,
		MIN_VIEWPORT_TOP = 1000;

	const $floatCTA = $('.js-float-cta');
	if (!$floatCTA.length) {
		return;
	}

	let timeout = null,
		dLSent = false,
		lastScrollTop = $(window).scrollTop();

	attachFloatCtaCallbacks();
	attachFloatSwitchCallbacks();

	// init
	onScroll();

	function attachFloatSwitchCallbacks() {
		const $floatSwitch = $('.js-float-switch');
		if (!$floatSwitch.length) {
			return;
		}

		// Prevent duplicate events, which occur on page with vue calculator
		$floatSwitch.off('.clickcta');
		$floatSwitch.on('click.clickcta', switchEnergyType);

		function switchEnergyType() {
			// Text switching
			const $this = $(this);
			const $text = $this.parent().find('.float-cta__text');
			const text = $text.text();
			$text.text($text.data('switch-text'));
			$text.data('switch-text', text);
		}
	}

	function attachFloatCtaCallbacks() {
		// Prevent duplicate events, which occur on page with vue calculator
		$(window).off('.ctaScroll');
		$(window).on('scroll.ctaScroll', onScroll);

		// Prevent duplicate events, which occurs on page with vue calculator
		$('.js-float-cta-control').off('.clickctatoggle');
		$('.js-float-cta-control').on('click.clickctatoggle', toggleCtaMinification);
	}

	function isInViewport($element) {
		if (!$element.length || !$element.is(':visible')) {
			return false;
		}

		const elementTop = $element.offset().top,
			elementBottom = elementTop + $element.outerHeight(),
			viewportTop = $(window).scrollTop(),
			viewportBottom = viewportTop + $(window).height();

		return (
			(elementTop > viewportTop && elementTop < viewportBottom) ||
			(elementBottom > viewportTop && elementBottom < viewportBottom) ||
			(elementTop < viewportTop && elementBottom > viewportBottom)
		);
	}

	function onScroll() {
		const viewportTop = $(window).scrollTop(),
			$guide = $('.guide__calculator, .calc-result').first();

		clearTimeout(timeout);

		if (isInViewport($guide)) {
			hideCta();
			return;
		}

		if (viewportTop < MIN_VIEWPORT_TOP || viewportTop > lastScrollTop) {
			hideCta();
		} else if (viewportTop < lastScrollTop) {
			showCta();
		}

		if (viewportTop > MIN_VIEWPORT_TOP) {
			timeout = setTimeout(showCta, TIMEOUT_MS);
		}

		lastScrollTop = viewportTop;
	}

	function showCta() {
		const scrollTop = $(window).scrollTop();
		if (scrollTop < MIN_VIEWPORT_TOP) {
			return;
		}

		$floatCTA.addClass('is-floaty');

		if (!$floatCTA.hasClass('is-minified') && !dLSent) {
			sendDatalayers('popupOpen');

			// call open on scroll only once
			dLSent = true;
		}
	}

	function hideCta() {
		$floatCTA.removeClass('is-floaty');
	}

	function toggleCtaMinification() {
		$('.js-float-cta').toggleClass('is-minified');

		if ($('.js-float-cta').hasClass('is-minified')) {
			sendDatalayers('popupClose');
		} else {
			sendDatalayers('popupOpen');
		}
	}

	function sendDatalayers(event) {
		try {
			let text = $.trim($('.float-cta__text').text());
			dataLayer.push({
				event: event,
				popupName: text,
			});
		} catch (err) {
			console.error('Could not push data layer: ' + err);
		}
	}
};
